import styled, { css } from 'styled-components';

interface WrapperProps {
  hasSubCategory?: boolean;
}
interface StickyWrapperProps {
  sticky?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  width: 100%;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    position: relative;
    display: block;
    padding-top: 56px;

    ${({ hasSubCategory }) =>
      hasSubCategory &&
      css`
        padding-top: 104px;
      `}
  }

  ${({ theme }) => theme.media.mobile} {
    padding-left: 16px;
    padding-right: 16px;
  }

  ${({ theme }) => theme.media.tablet} {
    padding-left: 32px;
    padding-right: 32px;
  }
`;

export const LNBWrapper = styled.div`
  ${({ theme }) => theme.media.pc} {
    margin-right: 30px;
  }
`;

export const StickyWrapper = styled.div<StickyWrapperProps>`
  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    ${({ sticky }) =>
      sticky &&
      css`
        position: fixed;
        top: 55px;
        left: 0;
        z-index: 10;
        background-color: #fff;
      `}
  }

  ${({ theme }) => theme.media.mobile} {
    padding: 0 16px 16px;
  }

  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px 16px;
  }
`;
